import {
    GET_USER,
} from '../actions/AuthActions';

const initialState = {};

const AuthReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_USER: {
            return {...action.payload};
        }
        default: {
            return {...state};
        }
    }
};

export default AuthReducer;
